import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

/** Envuelve cada ruta con una entrada suave (fade + ligero desplazamiento). */
export default function SoftPageOutlet() {
  const location = useLocation();
  return (
    <div key={location.pathname} className="ui-page-enter">
      <Outlet />
    </div>
  );
}
